"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "deleteMeetingAttendee", {
  enumerable: true,
  get: function get() {
    return _deleteMeetingAttendee["default"];
  }
});
Object.defineProperty(exports, "disableAttendeeScreenShare", {
  enumerable: true,
  get: function get() {
    return _disableAttendeeScreenShare["default"];
  }
});
Object.defineProperty(exports, "removeAttendeeCamera", {
  enumerable: true,
  get: function get() {
    return _removeAttendeeCamera["default"];
  }
});
Object.defineProperty(exports, "removeAttendeeFromMeeting", {
  enumerable: true,
  get: function get() {
    return _removeAttendeeFromMeeting["default"];
  }
});
Object.defineProperty(exports, "removeDirectorAttendee", {
  enumerable: true,
  get: function get() {
    return _removeDirectorAttendee["default"];
  }
});
Object.defineProperty(exports, "setAttendeeBackgroundFilter", {
  enumerable: true,
  get: function get() {
    return _setAttendeeBackgroundFilter["default"];
  }
});
Object.defineProperty(exports, "setAttendeeCameraStatus", {
  enumerable: true,
  get: function get() {
    return _setAttendeeCameraStatus["default"];
  }
});
Object.defineProperty(exports, "setAttendeeContentShareAudioProfile", {
  enumerable: true,
  get: function get() {
    return _setAttendeeContentShareAudioProfile["default"];
  }
});
Object.defineProperty(exports, "setAttendeeDetails", {
  enumerable: true,
  get: function get() {
    return _setAttendeeDetails["default"];
  }
});
Object.defineProperty(exports, "setAttendeeMuteStatus", {
  enumerable: true,
  get: function get() {
    return _setAttendeeMuteStatus["default"];
  }
});
Object.defineProperty(exports, "setAttendeeName", {
  enumerable: true,
  get: function get() {
    return _setAttendeeName["default"];
  }
});
Object.defineProperty(exports, "setAttendeeNetworkHealth", {
  enumerable: true,
  get: function get() {
    return _setAttendeeNetworkHealth["default"];
  }
});
Object.defineProperty(exports, "setAttendeePresence", {
  enumerable: true,
  get: function get() {
    return _setAttendeePresence["default"];
  }
});
Object.defineProperty(exports, "setAttendeeReceivedFrame", {
  enumerable: true,
  get: function get() {
    return _setAttendeeReceivedFrame["default"];
  }
});
Object.defineProperty(exports, "setAttendeeTile", {
  enumerable: true,
  get: function get() {
    return _setAttendeeTile["default"];
  }
});
Object.defineProperty(exports, "setAttendeeVoiceIntensity", {
  enumerable: true,
  get: function get() {
    return _setAttendeeVoiceIntensity["default"];
  }
});
Object.defineProperty(exports, "setDesiredAttendeeBackgroundFilter", {
  enumerable: true,
  get: function get() {
    return _setDesiredAttendeeBackgroundFilter["default"];
  }
});
Object.defineProperty(exports, "setDesiredAttendeeCameraStatus", {
  enumerable: true,
  get: function get() {
    return _setDesiredAttendeeCameraStatus["default"];
  }
});
Object.defineProperty(exports, "setDesiredAttendeeMuteStatus", {
  enumerable: true,
  get: function get() {
    return _setDesiredAttendeeMuteStatus["default"];
  }
});
Object.defineProperty(exports, "setMixerAttendee", {
  enumerable: true,
  get: function get() {
    return _setMixerAttendee["default"];
  }
});
Object.defineProperty(exports, "setMultipleDesiredAttendeeCameraStatuses", {
  enumerable: true,
  get: function get() {
    return _setMultipleDesiredAttendeeCameraStatuses["default"];
  }
});
Object.defineProperty(exports, "setMultipleDesiredAttendeeMuteStatuses", {
  enumerable: true,
  get: function get() {
    return _setMultipleDesiredAttendeeMuteStatuses["default"];
  }
});
Object.defineProperty(exports, "syncPresenterAttendeeIds", {
  enumerable: true,
  get: function get() {
    return _syncPresenterAttendeeIds["default"];
  }
});
Object.defineProperty(exports, "toggleAgoraAttendeeCameraStatus", {
  enumerable: true,
  get: function get() {
    return _toggleAgoraAttendeeCameraStatus["default"];
  }
});
Object.defineProperty(exports, "toggleAgoraAttendeeMuteStatus", {
  enumerable: true,
  get: function get() {
    return _toggleAgoraAttendeeMuteStatus["default"];
  }
});
var _setAttendeeName = _interopRequireDefault(require("./setAttendeeName"));
var _setAttendeeTile = _interopRequireDefault(require("./setAttendeeTile"));
var _setAttendeeMuteStatus = _interopRequireDefault(require("./setAttendeeMuteStatus"));
var _toggleAgoraAttendeeMuteStatus = _interopRequireDefault(require("./toggleAgoraAttendeeMuteStatus"));
var _setAttendeeNetworkHealth = _interopRequireDefault(require("./setAttendeeNetworkHealth"));
var _setAttendeeReceivedFrame = _interopRequireDefault(require("./setAttendeeReceivedFrame"));
var _setMultipleDesiredAttendeeMuteStatuses = _interopRequireDefault(require("./setMultipleDesiredAttendeeMuteStatuses"));
var _removeDirectorAttendee = _interopRequireDefault(require("./removeDirectorAttendee"));
var _setAttendeeCameraStatus = _interopRequireDefault(require("./setAttendeeCameraStatus"));
var _setDesiredAttendeeMuteStatus = _interopRequireDefault(require("./setDesiredAttendeeMuteStatus"));
var _setMultipleDesiredAttendeeCameraStatuses = _interopRequireDefault(require("./setMultipleDesiredAttendeeCameraStatuses"));
var _setDesiredAttendeeCameraStatus = _interopRequireDefault(require("./setDesiredAttendeeCameraStatus"));
var _removeAttendeeCamera = _interopRequireDefault(require("./removeAttendeeCamera"));
var _setMixerAttendee = _interopRequireDefault(require("./setMixerAttendee"));
var _disableAttendeeScreenShare = _interopRequireDefault(require("./disableAttendeeScreenShare"));
var _removeAttendeeFromMeeting = _interopRequireDefault(require("./removeAttendeeFromMeeting"));
var _setAttendeeDetails = _interopRequireDefault(require("./setAttendeeDetails"));
var _setAttendeeBackgroundFilter = _interopRequireDefault(require("./setAttendeeBackgroundFilter"));
var _setDesiredAttendeeBackgroundFilter = _interopRequireDefault(require("./setDesiredAttendeeBackgroundFilter"));
var _syncPresenterAttendeeIds = _interopRequireDefault(require("./syncPresenterAttendeeIds"));
var _setAttendeeContentShareAudioProfile = _interopRequireDefault(require("./setAttendeeContentShareAudioProfile"));
var _setAttendeePresence = _interopRequireDefault(require("./setAttendeePresence"));
var _setAttendeeVoiceIntensity = _interopRequireDefault(require("./setAttendeeVoiceIntensity"));
var _deleteMeetingAttendee = _interopRequireDefault(require("./deleteMeetingAttendee"));
var _toggleAgoraAttendeeCameraStatus = _interopRequireDefault(require("./toggleAgoraAttendeeCameraStatus"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }